export default __webpack_public_path__ + "static/media/i_pill_email.90a69308.svg";